import AppointmentTime from './AppointmentTime'

export default AppointmentTime